export default "__VITE_ASSET__6glqNrc0__"